export default "__VITE_ASSET__BYV_Zya$__"